if (document.querySelector('.blog-listing')) {
    document.addEventListener('DOMContentLoaded', () => {
        const currentCell = document.querySelector('.blog-listing__cell--current');
        const dropdown = document.querySelector('.blog-listing__dropdown');
        const wrap = document.querySelector('.blog-listing__wrap');
        const ul = document.querySelector('.blog-listing__ul');
    
        function updateHeight() {
            if (dropdown.getAttribute('data-expanded') === 'true') {
                wrap.style.height = `${ul.scrollHeight}px`;
            } else {
                wrap.style.height = '';
            }
        }
    
        currentCell.addEventListener('click', () => {
            const isExpanded = dropdown.getAttribute('data-expanded') === 'true';
            dropdown.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
    
            // Toggle the rotated class
            currentCell.classList.toggle('blog-listing__cell--current-rotated');
    
            updateHeight();
        });
    
        // Update height on window resize
        window.addEventListener('resize', updateHeight);
    
        // Initial height update in case the page is loaded with the dropdown expanded
        updateHeight();
    });
    
}